import { createReducer, on } from '@ngrx/store';
import { OrdersState } from '../../models/orders-state.model';
import * as orderActions from '../actions/orders.action';


export const initialOrdersState: OrdersState = {
  orders: [],
  pendingOrders: [],
  inProgressOrders: [],
  finishedOrders: [],
  manualOrders: [],
  finishedOrdersWithCashToCollect: [],
  order: null,
  isLoading: false,
  error: null,
  page: 1,
  totalItems: 0,
  totalPages: 0,
  calculatedOrderRoute: null,
  selectedOrderId: null,
  selectedOrder: null,
  vehicleTypes: [],
  
};

export const ordersReducer = createReducer(
    initialOrdersState,

   on(orderActions.updateOrder, (state, action) => ({
    ...state,
    order: action.order,
    })),
    on(orderActions.loadOrders, (state) => {
        console.log('loadOrders action dispatched');
        return {
            ...state,
            isLoading: true,
        };
    }),
    on(orderActions.loadOrdersSuccess, (state, action) => ({
        ...state,
        orders: action.orders.items,
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadOrdersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadManualOrders, (state) => ({
        ...state,
        isLoading: true,
      })),
      on(orderActions.loadManualOrdersSuccess, (state, action) => ({
        ...state,
        manualOrders: action.orders.items,
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
      })),
      on(orderActions.loadManualOrdersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
      })),
    on(orderActions.loadOrderById, (state) => ({
        ...state,
        // isLoading: true,
    })),
    on(orderActions.loadOrderByIdSuccess, (state, action) => {
        const selectedOrder = action.orders.items.find(order => order.id === action.id);
        return {
          ...state,
          orders: action.orders.items,
          selectedOrder: selectedOrder || null,
          isLoading: false,
        };
      }),
    on(orderActions.loadOrderByIdFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadPendingOrders, (state) => ({
        ...state,
        // isLoading: true,
    })),
    on(orderActions.loadPendingOrdersSuccess, (state, action) => ({
        ...state,
        pendingOrders: action.orders.items,
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadPendingOrdersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadInProgressOrders, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.loadInProgressOrdersSuccess, (state, action) => ({
        ...state,
        inProgressOrders: action.orders.items,
        selectedOrder: action.orders.items[0],
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadInProgressOrdersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadFinishedOrders, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.loadFinishedOrdersSuccess, (state, action) => ({
        ...state,
        finishedOrders: action.orders.items,
        selectedOrder: action.orders.items[0],
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadFinishedOrdersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadFinishedOrdersWithCashToCollect, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.loadFinishedOrdersWithCashToCollectSuccess, (state, action) => ({
        ...state,
        finishedOrdersWithCashToCollect: action.orders.items,
        selectedOrder: action.orders.items[0],
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadFinishedOrdersWithCashToCollectFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadOrdersByRiderId, (state) => ({
        ...state,
        // isLoading: true,
    })),
    on(orderActions.loadOrdersByRiderIdSuccess, (state, action) => ({
        ...state,
        orders: action.orders.items,
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadOrdersByRiderIdFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.loadManualOrdersByRiderId, (state) => ({
        ...state,
        // isLoading: true,
    })),
    on(orderActions.loadManualOrdersByRiderIdSuccess, (state, action) => ({
        ...state,
        manualOrders: action.orders.items,
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
        isLoading: false,
    })),
    on(orderActions.loadManualOrdersByRiderIdFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.createOrder, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.createOrderSuccess, (state, action) => ({
        ...state,
        orders: [...state.orders, action.order],
        isLoading: false,
    })),
    on(orderActions.createOrderFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.createManualOrder, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.createManualOrderSuccess, (state, action) => ({
        ...state,
        orders: [...state.orders, action.order],
        isLoading: false,
    })),
    on(orderActions.createManualOrderFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.editOrder, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.editOrderSuccess, (state, action) => ({
        ...state,
        orders: [...state.orders, action.order],
        isLoading: false,
    })),
    on(orderActions.editOrderFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.assignOrderToRider, (state) => ({
        ...state,
        // isLoading: true,
    })),
    on(orderActions.assignOrderToRiderSuccess, (state, action) => ({
        ...state,
        pendingOrders: state.pendingOrders.filter(order => order.id !== action.order.service_request.service),
      })),
    on(orderActions.assignOrderToRiderFailure, (state, action) => ({
        ...state,
        error: action.error,
        // isLoading: false,
    })),
    on(orderActions.calculateOrderRoute, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.calculateOrderRouteSuccess, (state, action) => ({
        ...state,
        calculatedOrderRoute: action.calculatedOrderRoute,
        isLoading: false,
    })),
    on(orderActions.calculateOrderRouteFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.currentOrder, (state, action) => ({
        ...state,
        selectedOrder: action.order, 
    })),
    on(orderActions.currentOrderId, (state, action) => ({
        ...state,
        selectedOrderId: action.id,
    })),
    on(orderActions.cancelOrder, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.cancelOrderSuccess, (state, action) => ({
        ...state,
        // orders: state.orders.filter(order => order.id == action.order.id),
        isLoading: false,
    })),
    on(orderActions.cancelOrderFailure, (state, action) => ({
        ...state,   
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.reassignOrder, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.reassignOrderSuccess, (state, action) => ({
        ...state,
        // orders: state.orders.map(order =>
        //     order.id === action.order_id ? { ...order, ...action.payload } : order
        //   ),
        isLoading: false,   
    })),
    on(orderActions.reassignOrderFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(orderActions.selectOrder, (state, { order }) => ({ 
        ...state, 
        selectedOrder: order
     })),
    on(orderActions.clearSelectedOrder, state => ({ 
        ...state, 
        selectedOrder: null
     })),
     on(orderActions.confirmCashDelivered, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.confirmCashDeliveredSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        finishedOrdersWithCashToCollect: state.finishedOrdersWithCashToCollect.filter(order => order.id !== action.order.id),
    })),
    on(orderActions.confirmCashDeliveredFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error,
    })),
    on(orderActions.loadVehicleTypes, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(orderActions.loadVehicleTypesSuccess, (state, action) => ({
        ...state,
        vehicleTypes: action.vehicleTypes,
        isLoading: false,
    })),
    on(orderActions.loadVehicleTypesFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
);